export const SHARED = 'shared'
export const APPROVED = 'approved'
export const PENDING = 'pending'
export const DECLINED = 'declined'
